<script setup>
import { computed, watch, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import { Toaster } from '@/components/ui/sonner'

const route = useRoute()

// Lazy-load layouts
const layouts = {
    admin: defineAsyncComponent(() => import('./layouts/AdminLayout.vue')),
    blank: defineAsyncComponent(() => import('./layouts/BlankLayout.vue')),
}

const layout = computed(() => {
    const layoutName = route.meta?.layout || 'admin'
    return layouts[layoutName] || layouts.admin
})

// Update document title based on route
watch(
    () => route.meta?.title,
    (title) => {
        document.title = title ? `${title} - IdentityServer Admin` : 'IdentityServer Admin'
    },
    { immediate: true }
)
</script>

<template>
    <component :is="layout">
        <router-view />
    </component>
    <Toaster position="top-right" :rich-colors="true" />
</template>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
